import React from "react";
import { cn } from "../../../lib/utils";

/**
 * Shell for the expanded messages dock (list or chat layout).
 * @param {{ header: React.ReactNode, children: React.ReactNode, className?: string }} props
 * @returns {JSX.Element}
 */
function MessageDockPanel({ header, children, className }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Messages"
      className={cn(
        "flex w-[min(100vw-2rem,22rem)] max-w-[calc(100vw-2rem)] flex-col overflow-hidden rounded-2xl border border-border bg-secondary shadow-xl",
        /* Explicit height so flex descendants (ChatList / ChatFrame) get a bounded box and overflow/scroll works */
        "h-[min(85vh,36rem)] min-h-0",
        className
      )}
    >
      {header != null && <div className="shrink-0 border-b border-border">{header}</div>}
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{children}</div>
    </div>
  );
}

export { MessageDockPanel };
